export function updateVideoCount(video_count) {
  return function(dispatch){
    dispatch({type: "UPDATE_VIDEO_COUNT", payload: video_count})
  }
}
